import { render, staticRenderFns } from "./demos-mobile.vue?vue&type=template&id=8ae4b9b6&"
import script from "./demos-mobile.vue?vue&type=script&lang=js&"
export * from "./demos-mobile.vue?vue&type=script&lang=js&"
import style0 from "./demos-mobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports